import { NavLink } from 'react-router-dom';

import { Box, Button, IconButton, Link, SxProps, Theme, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { AlertTriangleOutline, MenuOutline } from '../../icons';
import { useMainLayoutStore } from '../../newStore/mainLayoutStore';
import { paths } from '../../utils/navigation';
import { ChatNotifications } from './ChatNotifications';
import { UserNav } from './UserNav';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    position: 'static',
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #e7eaec',
    zIndex: 95,
    '@media print': {
      display: 'none',
    },
  },
  content: {
    display: 'flex',
    height: '60px',
    alignItems: 'center',
    padding: '4px 25px',
    boxSizing: 'border-box',
    justifyContent: 'flex-end',
    '@media (max-width: 899px)': {
      justifyContent: 'space-between',
    },
  },
  menuButton: {
    display: { md: 'none' },
    color: (theme) => theme.palette.secondary.main,
  },
  mainContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '30px',
  },
  extraContainer: {
    alignItems: 'center',
    gap: '12px',
    display: { xs: 'none', md: 'flex' },
  },
  featureRequestText: {
    fontSize: '13px',
    color: '#FA8C16',
    fontWeight: 500,
  },
  featureRequestLink: {
    borderRadius: '26px',
    background: '#FA8C16',
    paddingRight: '20px',
    paddingLeft: '20px',
    color: '#FFFFFF',
    textDecoration: 'none',
    padding: '6px 20px',
    textTransform: 'none',
    border: '1px solid #F8AC59',
    fontSize: '14px',
    fontWeight: 600,
  },
  findingsButton: {
    borderRadius: '26px',
    background: '#D8EFFE',
    paddingRight: '20px',
    paddingLeft: '20px',
    color: '#1F52B3',
    border: 'solid 1px #3E8FFA',
    '& svg': {
      width: '16px',
      height: '16px',
    },
    '&:hover': {
      background: '#3E8FFA',
      color: '#FFFFFF',
    },
  },
};

export function MainTopBar() {
  const lang = useLanguage();
  const { setOpenMobile, expandedDesktop } = useMainLayoutStore();

  return (
    <Box sx={customStyles.root}>
      <Box sx={customStyles.content}>
        <IconButton
          onClick={() => setOpenMobile(true)}
          sx={customStyles.menuButton}
        >
          <MenuOutline
            fontSize='inherit'
            color='inherit'
          />
        </IconButton>
        <Box sx={customStyles.mainContainer}>
          <Box sx={customStyles.extraContainer}>
            <Typography
              sx={{
                ...customStyles.featureRequestText,
                display: { xs: 'none', md: expandedDesktop ? 'none' : 'block', lg: 'block' },
              }}
            >
              {lang.mainTopBar.featureRequestText}
            </Typography>
            <Link
              href='https://godatascope.feedbear.com/boards/feature-requests'
              target='_blank'
              rel='noreferrer'
              sx={customStyles.featureRequestLink}
              variant='button'
            >
              {lang.mainTopBar.featureRequest}
            </Link>
            <NavLink to={`${paths.findings.index}?open_create=true`}>
              <Button
                variant='contained'
                endIcon={<AlertTriangleOutline />}
                sx={customStyles.findingsButton}
              >
                {lang.mainTopBar.createIssue}
              </Button>
            </NavLink>
            <ChatNotifications />
          </Box>
          <UserNav />
        </Box>
      </Box>
    </Box>
  );
}
